import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import alert_mixin from '@/mixins/alert';
import template from '@/../templates/devices-layout-new.hbs';

    var DevicesLayout = Marionette.View.extend(alert_mixin).extend({
        template: Handlebars.compile(template),
        className: 'devices-container',
        regions: {
            filters: '.devicegroup-filters',
            controls: '.controls',
            content: '.content-region',
            pagination_controls: '.pagination',
            alerts: '.alerts'
        },
        ui: {
            filter: '.filter',
            filter_menu_title: '.filters .menu-title'
        },
        events: {
            'click @ui.filter': 'on_change_filter'
        },
        onRender: function() {
            // Default to "All" filter
            this.ui.filter_menu_title.text('All');
        },
        on_change_filter: function(e) {
            this.set_filter(e.target.rel);
            this.ui.filter_menu_title.text(e.target.text);
        },
        set_filter: function(filter_key) {
            // If we show additional views via this layout, this needs to be smarter
            var devices_list = this.childView;
            devices_list.filter = devices_list.options.filters[filter_key];
            devices_list.render();
        }
    });
    export default DevicesLayout;

